module.exports = __webpack_public_path__ + "img/Libra.7972e9ec.png";